module.exports = __webpack_public_path__ + "ATS/img/icon_huifu.ed8a2d86.svg";